import React from 'react';
import { InterPoint } from '@saviynt/common';

import SodUserCard from '../SodUserCard';

interface UserChipProps {
  firstName: string | null;
  lastName: string | null;
  userName: string | null;
  isPrefixInterpoint?: boolean;
  avatarSize?: 'xxSmall' | 'xSmall' | 'small' | 'medium' | 'large' | 'xLarge';
}

/**
 * User chip component for displaying user information
 */
function SodUserChip({
  firstName,
  lastName,
  userName,
  isPrefixInterpoint = true,
  avatarSize,
}: UserChipProps) {
  if (!firstName && !lastName && !userName) {
    return null;
  }

  if (
    firstName?.trim().length === 0 &&
    lastName?.trim().length === 0 &&
    userName?.trim().length === 0
  ) {
    return null;
  }

  return (
    <>
      <SodUserCard
        firstName={firstName ?? undefined}
        lastName={lastName ?? undefined}
        userName={userName ?? undefined}
        link=''
        trailContent={false}
        avatarSize={avatarSize ?? undefined}
      />
      {isPrefixInterpoint && <InterPoint color='neutralBold' font='body2' />}
    </>
  );
}

SodUserChip.defaultProps = {
  isPrefixInterpoint: null,
  avatarSize: null,
};

export default SodUserChip;
